import Vue from 'vue'
import Router from 'vue-router'
import Personal from './personal'

Vue.use(Router)

let RouteList = [{
    path: '/home',
    component: resolve => require(['@/views/layout/App.vue'], resolve),
    meta: {
        title: '首页',
        keepAlive: false,
    },
    children: [{
        path: '/personal',
        name: 'personal',
        meta: {
            title: '个人中心',
            keepAlive: false
        },
        component: resolve => require(['@/views/personal/Index.vue'], resolve),
    },
    {
        path: '/home',
        name: 'Dashboard',
        meta: {
            title: '首页',
            keepAlive: false
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },
    {
        path: '/business_list',
        name: 'business_list',
        meta: {
            title: '商家管理',
            keepAlive: false,
            activeMenu: '/business_list'
        },
        component: resolve => require(['@/views/local/business_list.vue'], resolve),
    },
    {
        path: '/business_edit',
        name: 'business_edit',
        meta: {
            title: '商家信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/business_edit.vue'], resolve),
    },
    {
        path: '/inSettlement_list',
        name: 'inSettlement_list',
        meta: {
            title: '结算中',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/inSettlement_list.vue'], resolve),
    },
    {
        path: '/store_list',
        name: 'store_list',
        meta: {
            title: '门店管理',
            keepAlive: false,
            activeMenu: '/business_list'
        },
        component: resolve => require(['@/views/local/store_list.vue'], resolve),

    },
    {
        path: '/store_edit',
        name: 'store_edit',
        meta: {
            title: '门店信息',
            keepAlive: false,
        },
        component: resolve => require(['@/views/local/com/store_edit.vue'], resolve),
    },
    {
        path: '/member_list',
        name: 'member_list',
        meta: {
            title: '成员管理',
            keepAlive: false,
            activeMenu: '/business_list'
        },
        component: resolve => require(['@/views/local/member_list.vue'], resolve),
    },
    {
        path: '/goods_list',
        name: 'goods_list',
        meta: {
            title: '商品管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/goods_list.vue'], resolve),
    },
    {
        path: '/goods_edit',
        name: 'goods_edit',
        meta: {
            title: '商品信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/goods_edit.vue'], resolve),
    },
    {
        path: '/local_order',
        name: 'local_order',
        meta: {
            title: '订单管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/local_order.vue'], resolve),
    },
    {
        path: '/comment_list',
        name: 'comment_list',
        meta: {
            title: '评论管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/comment_list.vue'], resolve),
    },
    // 本地生活提现记录
    {
        path: '/local_records',
        name: 'local_records',
        meta: {
            title: '提现记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/local_records.vue'], resolve),
    },
    // 资金流水
    {
        path: '/withdrawal_records',
        name: 'withdrawalRecords',
        meta: {
            title: '资金流水',
            keepAlive: false
        },
        component: resolve => require(['@/views/finance/withdrawal_records.vue'], resolve),
    },
    // 提现记录
    {
        path: '/reflect_list',
        name: 'reflect_list',
        meta: {
            title: '提现记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/finance/reflect_list.vue'], resolve),
    },
    // 财务管理
    {
        path: '/finance',
        name: 'finance',
        meta: {
            title: '财务管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/finance/finance.vue'], resolve),
    },
    // 合作管理
    {
        path: '/cooperation',
        name: 'cooperation',
        meta: {
            title: '合作管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/expert/cooperation.vue'], resolve),
    },
    // 达人推广
    {
        path: '/promotion',
        name: 'promotion',
        meta: {
            title: '合作管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/expert/promotion.vue'], resolve),
    },
    {
        path: '/tutorial',
        name: 'tutorial',
        meta: {
            title: '教程',
            keepAlive: false
        },
        component: resolve => require(['@/views/home/tutorial.vue'], resolve),
    },
    {
        path: '/tutorial_detail',
        name: 'tutorial_detail',
        meta: {
            title: '教程详情',
            keepAlive: false
        },
        component: resolve => require(['@/views/home/tutorial_detail.vue'], resolve),
    },
    {
        path: '/promoter',
        name: 'promoter',
        meta: {
            title: '达人管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/promoter.vue'], resolve),
    },
    // 任务列表
    {
        path: '/jhtask',
        name: 'jhtask',
        meta: {
            title: '任务列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/jhtask.vue'], resolve),
    },
    // 任务记录
    {
        path: '/taskRecord',
        name: 'taskRecord',
        meta: {
            title: '任务记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/taskRecord.vue'], resolve),
    },
    // 推广礼包
    {
        path: '/giftPackage',
        name: 'giftPackage',
        meta: {
            title: '推广礼包',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/giftPackage.vue'], resolve),
    },
    {
        path: '/taskLevel',
        name: 'taskLevel',
        meta: {
            title: '基础信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/taskLevel.vue'], resolve),
    },
    {
        path: '/statistics',
        name: 'statistics',
        meta: {
            title: '碰一碰统计',
            keepAlive: false
        },
        component: resolve => require(['@/views/statistics/statistics.vue'], resolve),
    },
    {
        path: '/theCharts',
        name: 'theCharts',
        meta: {
            title: '统计排行榜',
            keepAlive: false
        },
        component: resolve => require(['@/views/statistics/theCharts.vue'], resolve),
    },
    {
        path: '/homeVideo',
        name: 'homeVideo',
        meta: {
            title: '品牌视频',
            keepAlive: false
        },
        component: resolve => require(['@/views/home/homeVideo.vue'], resolve),
    },
    // 结算中说明
    {
        path: '/lock_order',
        name: 'lock_order',
        meta: {
            title: '结算中说明',
            keepAlive: false
        },
        component: resolve => require(['@/views/finance/lock_order.vue'], resolve),
    },
    // 精选联盟
    {
        path: '/exclusive',
        name: 'exclusive',
        meta: {
            title: '精选联盟',
            keepAlive: false
        },
        component: resolve => require(['@/views/exclusive/exclusive.vue'], resolve),
    },
    ]
},
{
    path: '/login',
    name: 'Login',
    meta: {
        title: '登录',
        keepAlive: false
    },
    components: {
        blank: resolve => require(['@/views/login/Login.vue'], resolve),
    }
},
// 用户协议
{
    path: '/agreement',
    name: 'agreement',
    meta: {
        title: '用户协议',
        keepAlive: false
    },
    component: resolve => require(['@/views/login/agreement.vue'], resolve),
},
// 隐私条款
{
    path: '/term',
    name: 'term',
    meta: {
        title: '隐私条款',
        keepAlive: false
    },
    component: resolve => require(['@/views/login/term.vue'], resolve),
},
// 推广查询
{
    path: '/video',
    name: 'video',
    meta: {
        title: '推广查询',
        keepAlive: false
    },
    components: {
        blank: resolve => require(['@/views/login/video.vue'], resolve),
    }
},

{
    path: '/*',
    name: 'NotFound',
    meta: {
        title: '404',
        keepAlive: true
    },
    components: {
        blank: resolve => require(['@/views/error/404.vue'], resolve),
    }
},

]

export default new Router({
    routes: RouteList
})